export default {
  ls_token: 'lltoken',
  support_mail: 'info@boligninja.dk'
};
